var _defs, _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictographFullSmileLineEyesCyanDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#37193c;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#7fb0f6;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 42.17,
    y: 48.68,
    width: 159.86,
    height: 159.86,
    transform: "translate(244.19 257.21) rotate(-180)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m126.77,217.14c-4,0-8.04-.38-12.08-1.14-15.9-3.02-29.76-11.7-39.01-24.46-9.32-12.85-12.87-28.27-9.99-43.43l9.82,1.86c-2.36,12.43.58,25.1,8.26,35.7,7.75,10.68,19.4,17.97,32.78,20.51,13.39,2.54,26.89.03,38.02-7.07,11.03-7.04,18.41-17.76,20.77-30.19l9.82,1.86c-2.88,15.16-11.83,28.21-25.21,36.75-9.92,6.33-21.39,9.61-33.19,9.61Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 74.03,
    y: 42.69,
    width: 10,
    height: 99.77,
    transform: "translate(-14.19 170.84) rotate(-89.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m201.4,122.63c-.11,0-.22,0-.34,0-10.68-.09-20.69-4.33-28.18-11.94s-11.57-17.69-11.48-28.37l10,.08c-.07,8.01,2.99,15.57,8.61,21.28,5.62,5.71,13.12,8.89,21.13,8.96,8,.09,15.57-2.99,21.28-8.61,5.71-5.62,8.89-13.12,8.96-21.13l10,.08c-.09,10.68-4.33,20.69-11.94,28.18-7.53,7.41-17.48,11.48-28.03,11.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictographFullSmileLineEyesCyanDark);
export default __webpack_public_path__ + "static/media/pictograph-fullSmile-lineEyes-cyan-dark.c76a3d4ee2b78d2573d16a5455b98bd1.svg";
export { ForwardRef as ReactComponent };